'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _influencer__content = require('./influencer__content.vue');

var _influencer__content2 = _interopRequireDefault(_influencer__content);

var _influencer__social = require('./influencer__social.vue');

var _influencer__social2 = _interopRequireDefault(_influencer__social);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    props: ['post'],
    components: {
        influencerContent: _influencer__content2.default,
        influencerSocial: _influencer__social2.default
    }
};
if (module.exports.__esModule) module.exports = module.exports.default
;(typeof module.exports === "function"? module.exports.options: module.exports).template = "\n<div class=\"stream__box\">\n    <div class=\"stream__image\">\n        <influencer-content :post=\"post\"></influencer-content>\n    </div>\n    <div class=\"stream__share\">\n        <influencer-social :post=\"post\"></influencer-social>\n    </div>\n</div>\n"
if (module.hot) {(function () {  module.hot.accept()
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), true)
  if (!hotAPI.compatible) return
  if (!module.hot.data) {
    hotAPI.createRecord("_v-729046ce", module.exports)
  } else {
    hotAPI.update("_v-729046ce", module.exports, (typeof module.exports === "function" ? module.exports.options : module.exports).template)
  }
})()}